import RecentActivity from './../../presentation/recentActivity/RecentActivity.jsx';

const RecentActivityContainer = (props) => {
	const { badgeList, assignmentsSent, isLoading, error } = props;

	return (
		<RecentActivity
			isLoading={isLoading}
			badgeList={badgeList}
			assignmentsSent={assignmentsSent}
			error={error}
		/>
	);
};

export default RecentActivityContainer;
